"use client";

import * as React from "react";
import { RWA_ICON } from "~/consts";

import type { JSX } from "react";

// // // //

/**
 * GlobalError
 * Catches errors thrown by the root layout itself, which `error.tsx` cannot.
 *
 * NOTE - this file REPLACES the root layout when it renders, so it gets no
 * global stylesheet, no theme class and no providers. Everything here is
 * inlined on purpose - do not reach for Tailwind classes or repo components.
 */
export default function GlobalError(props: {
    error: Error & { digest?: string };
    retry: () => void;
}): JSX.Element {
    const { error, retry } = props;

    React.useEffect(() => {
        console.error(error);
    }, [error]);

    return (
        <html lang="en">
            <body
                style={{
                    margin: 0,
                    minHeight: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "1.5rem",
                    backgroundColor: "#ffffff",
                    color: "#111120",
                    fontFamily:
                        "TWK Lausanne, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif",
                    textAlign: "center",
                    padding: "1rem",
                }}
            >
                <title>RWA.xyz | Something went wrong</title>

                <img
                    src={RWA_ICON}
                    alt="RWA.xyz"
                    style={{ height: "4.5rem" }}
                />

                <h1 style={{ fontSize: "2.25rem", fontWeight: 400, margin: 0 }}>
                    Something went wrong.
                </h1>
                <p style={{ fontSize: "1.25rem", margin: 0 }}>
                    {"Sorry, we hit an unexpected error loading this page."}
                </p>
                {error.digest && (
                    <p
                        style={{
                            fontSize: "0.875rem",
                            opacity: 0.6,
                            margin: 0,
                        }}
                    >
                        Reference: {error.digest}
                    </p>
                )}

                <button
                    type="button"
                    onClick={() => retry()}
                    style={{
                        padding: "0.625rem 1.25rem",
                        borderRadius: "0.375rem",
                        border: "1px solid #1e293b",
                        background: "#1e293b",
                        color: "#ffffff",
                        fontSize: "1rem",
                        cursor: "pointer",
                    }}
                >
                    Try again
                </button>
            </body>
        </html>
    );
}
